import { useState, useEffect } from "react";
import store from "../redux/app/store";
import {
  setLoaderProcessesIncrement,
  setLoaderProcessesDecrement,
} from "../redux/features/applicationState/applicationStateSlice";

import toastManager from "../helpers/toastManager";

const useAxios = () => {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [controller, setController] = useState();

  const handleError = (error) => {
    if (error) {
      if (error?.code === "ERR_CANCELED") {
        // console.log("Request canceled");
        return;
      }

      const errorStatus = error.response?.status
        ? error.response.status
        : "Unknown Status";
      const errorData = error.response?.data ? error.response.data : {};

      setError(errorData);

      // Print for dubug purposes.
      console.log(error);
      if (errorStatus) {
        console.log(errorStatus);
      }
      if (errorData) {
        console.log(errorData);
      }
      // 2: General Django serializer error handling.
      // User input error.
      if (
        errorStatus &&
        errorData &&
        !errorData?.action_code &&
        error?.code !== "ERR_NETWORK"
      ) {
        // Extract and format error messages
        const errorMessages = Object.entries(errorData)
          .map(([field, errors]) => {
            let formattedErrors;

            if (Array.isArray(errors)) {
              formattedErrors = errors.join(", ");
            } else if (errors?.detail) {
              formattedErrors = errors.detail;
            } else {
              formattedErrors = JSON.stringify(errors);
            }

            return `${field}: ${formattedErrors}`;
          })
          .join("; ");

        toastManager("warning", "Issue with input!", errorMessages);
      }
      // 3: Server side error.
      else if (errorData?.action_code === "server_issue") {
        toastManager(
          "warning",
          "Server Issue!",
          "The server encountered an issue."
        );
      }
      // 4: Network error.
      else if (error?.code === "ERR_NETWORK") {
        toastManager(
          "error",
          "Network Error!",
          "Application cannot connect to the server."
        );
      }
    }
  };

  const handleLoading = (loadingStatus, url) => {
    // console.log(`Loading: ${loadingStatus}`);
    if (!url.includes("celery-progress")) {
      if (loadingStatus) {
        store.dispatch(setLoaderProcessesIncrement());
      } else {
        store.dispatch(setLoaderProcessesDecrement());
      }
    }
    setLoading(loadingStatus);
  };

  const axiosFetch = async (configObj) => {
    const {
      axiosInstance,
      method,
      url,
      requestConfig = {},
      sendSignal = false,
    } = configObj;

    try {
      handleLoading(true, url);
      const ctrl = new AbortController();
      setController(ctrl);

      const res = sendSignal
        ? await axiosInstance[method.toLowerCase()](url, {
            ...requestConfig,
            signal: ctrl.signal,
          })
        : await axiosInstance[method.toLowerCase()](url, requestConfig);

      setResponse(res.data);
    } catch (err) {
      handleError(err);
    } finally {
      handleLoading(false, url);
    }
  };

  useEffect(() => {
    // console.log(controller);

    // useEffect cleanup function
    return () => controller && controller.abort();
  }, [controller]);

  return { response, error, loading, axiosFetch };
};

export default useAxios;
